import { DistributionChannelFormData } from '../../../integrated-client/models'

export interface IDistributionChannelEditorData {
  distributionChannelData?: DistributionChannelFormData
  validation?: any
}
export class DistributionChannelEditorData implements IDistributionChannelEditorData {

  distributionChannelData?: DistributionChannelFormData
  validation?: any
}